import {
    FETCH_ERROR,
    GET_NEWS_DETAILS,
    GET_NEWS_UPDATE,
    GET_USER_BDAY,
    NOTIFICATIONS,
    READ_NOTIFICATIONS,
} from "shared/constants/ActionTypes";

const initialState = {
    error: null,
    userBdayList: [],
    newsAndUpdateList: [],
    newAndUpdateDetails: {},
    notificationsList: [],
};
export const homeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ERROR:
            return { ...state, error: payload };
        case GET_USER_BDAY:
            return { ...state, userBdayList: payload };
        case GET_NEWS_UPDATE:
            return { ...state, newsAndUpdateList: payload };
        case GET_NEWS_DETAILS:
            return {
                ...state,
                newAndUpdateDetails: payload,
            };
        case NOTIFICATIONS:
            return { ...state, notificationsList: payload };
        case READ_NOTIFICATIONS:
            return {
                ...state,
                notificationsList: {
                    ...state.notificationsList,
                    unReadCount: state.notificationsList.unReadCount - 1,
                    content: {
                        ...state.notificationsList.content,
                        content: [
                            ...state.notificationsList.content.content.map(
                                (item) =>
                                    item.id == payload.id ? payload : item
                            ),
                        ],
                    },
                },
            };
        default:
            return state;
    }
};
